import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, Media, UncontrolledCollapse } from 'reactstrap';
import styled from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronDown} from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

const StyledQuadrant = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'quadrant_color',
  })`
  display: initial;

  > ul li:before {
    background-color: ${props => props.quadrant_color};
  }
`;

export const ModalReportTT = ({ modal, toggle, current_item, user, showAllItems }) => {
    const questions = useSelector(state => state.questions);
    const items = useMemo(() => {
        if(!current_item) {
            return [];
        }

        if(showAllItems) {
            return questions.items.filter(item => item.quadrant.id === current_item.id)
        }

        return user.talents?.flatMap(talent => {
            if (!Array.isArray(talent.items)) {
                return [];  // Retorna un array vacío si `items` no es válido
            }
            return talent.items.filter(item => item.quadrant_id === current_item.id);
        });
    }, [questions.items, current_item, user?.talents])

    return (
        <Modal isOpen={modal} toggle={toggle} size='sm' className="w-100 modal-dialog-summary float-right">
            <ModalHeader toggle={toggle} className='pb-0'></ModalHeader>
            <ModalBody className='pt-2'>
                {
                    current_item && 
                    <div className={"modal-quadrant-" + current_item.name}>
                        <div className="d-flex align-items-center mb-3">
                            <div className="mb-0 mr-3">
                                <img
                                    className="icon"
                                    width="60"
                                    height="60"
                                    src={current_item.icon}
                                    alt={current_item.name}
                                />
                            </div>
                            <h2 className="libre-caslon-text-regular text-capitalize mb-0 h4">{current_item.name}</h2>
                        </div>
                        <StyledQuadrant
                            $quadrant_color={current_item.color}
                            className="text-left quadrant_description"
                            dangerouslySetInnerHTML={{ __html: current_item.description }}
                        >
                        </StyledQuadrant>

                        {current_item &&
                            (
                                <div>
                                {items.map(item =>
                                        <div
                                            key={'i_' + item.id}
                                            className={"item talent-item border rounded mb-2 p-2 modal-quadrant-" + item.quadrant}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div id={`toggler${item.id}`}>
                                                <Media className="align-items-center">
                                                    <Media left middle className="mr-3">
                                                        <Media object src={item.icon} width="44" height="44" alt={item.name} style={{ backgroundColor: current_item.color }} />
                                                    </Media>
                                                    <Media body>
                                                        <Media heading tag="h5" className="mb-0 text-reset">
                                                            {item.name}
                                                        </Media>
                                                    </Media>
                                                    <FontAwesomeIcon icon={faChevronDown} className='my-auto mr-1' />
                                                </Media>
                                            </div>

                                            <UncontrolledCollapse toggler={`#toggler${item.id}`}>
                                                <StyledQuadrant quadrant_color={current_item.color}
                                                    dangerouslySetInnerHTML={{ __html: item.result_description }} className="pt-2"></StyledQuadrant>
                                            </UncontrolledCollapse>
                                        </div>
                                )}
                                </div>
                            )
                        }
                    </div>
                }
            </ModalBody>
        </Modal>
    )
}
